export enum EnumSeverity {
    default = 'default',

    success = 'success',

    error = 'danger',

    warning = 'warning'
}
